export type MaintenanceType =
  | '375'
  | '750'
  | '1500'
  | 'week'
  | 'month'
  | 'year';

export interface AssetSopEntry {
  asset: string;
  type: MaintenanceType;
  url: string;
}

export type CustomerCode = string;

export type SquaresAssetSopData = Record<CustomerCode, AssetSopEntry[]>;

export const squaresAssetSopData: SquaresAssetSopData = {
  drn: [
    {
      asset: '381',
      type: '375',
      url: 'https://docs.google.com/document/d/1C5K29GdXRJpNzJDd2YE3J6FrnYIKbLas/edit',
    },
    {
      asset: '381',
      type: '750',
      url: 'https://docs.google.com/document/d/1uV4q0l4RQbYRhjU8YaMGXemvfI-R1m1j/edit',
    },
    {
      asset: '381',
      type: '1500',
      url: 'https://docs.google.com/document/d/14SrRsQpXGu7xfWBGw0sY6vkDELmod45G/edit',
    },
    {
      asset: '560',
      type: '375',
      url: 'https://docs.google.com/document/d/1VUkLa8Z-nPkoWjwcjWJw1x3yBcOk-xeq/edit',
    },
    {
      asset: '560',
      type: '750',
      url: 'https://docs.google.com/document/d/1ZbddjHOVVj9yM44peEEvcHYwyKUq3kGP/edit',
    },
    {
      asset: '560',
      type: '1500',
      url: 'https://docs.google.com/document/d/16USN_iDqyuhVyRyzpXmNJzBtQb_IcROD/edit',
    },
    {
      asset: '561',
      type: '375',
      url: 'https://docs.google.com/document/d/1VUkLa8Z-nPkoWjwcjWJw1x3yBcOk-xeq/edit',
    },
    {
      asset: '561',
      type: '750',
      url: 'https://docs.google.com/document/d/1ZbddjHOVVj9yM44peEEvcHYwyKUq3kGP/edit',
    },
    {
      asset: '561',
      type: '1500',
      url: 'https://docs.google.com/document/d/16USN_iDqyuhVyRyzpXmNJzBtQb_IcROD/edit',
    },
    {
      asset: '540',
      type: '375',
      url: 'https://docs.google.com/document/d/1VUkLa8Z-nPkoWjwcjWJw1x3yBcOk-xeq/edit',
    },
    {
      asset: '540',
      type: '750',
      url: 'https://docs.google.com/document/d/1ZbddjHOVVj9yM44peEEvcHYwyKUq3kGP/edit',
    },
    {
      asset: '540',
      type: '1500',
      url: 'https://docs.google.com/document/d/16USN_iDqyuhVyRyzpXmNJzBtQb_IcROD/edit',
    },
    {
      asset: '536',
      type: '375',
      url: 'https://docs.google.com/document/d/1VUkLa8Z-nPkoWjwcjWJw1x3yBcOk-xeq/edit',
    },
    {
      asset: '536',
      type: '750',
      url: 'https://docs.google.com/document/d/1ZbddjHOVVj9yM44peEEvcHYwyKUq3kGP/edit',
    },
    {
      asset: '536',
      type: '1500',
      url: 'https://docs.google.com/document/d/16USN_iDqyuhVyRyzpXmNJzBtQb_IcROD/edit',
    },
    {
      asset: '599',
      type: '375',
      url: 'https://docs.google.com/document/d/1VUkLa8Z-nPkoWjwcjWJw1x3yBcOk-xeq/edit',
    },
    {
      asset: '599',
      type: '750',
      url: 'https://docs.google.com/document/d/1ZbddjHOVVj9yM44peEEvcHYwyKUq3kGP/edit',
    },
    {
      asset: '599',
      type: '1500',
      url: 'https://docs.google.com/document/d/16USN_iDqyuhVyRyzpXmNJzBtQb_IcROD/edit',
    },
    {
      asset: '309',
      type: '375',
      url: 'https://docs.google.com/document/d/1ufIeIHSevaN8rvOvKG15EjqdxK8lomJc/edit',
    },
  ],
};
